<app-create-manufacturer-modal
  #createManufacturer
  [modalMessage]="app.text.part.discard"
  [modalTitle]="app.text.part.modalTitle"
  (ok)="createManufacturer()"
></app-create-manufacturer-modal>

<div class="tableFixHead clear">
  <table class="table table-striped col-md-8">
    <thead>
      <tr>
        @for (column of matchedItemColumns; track column) {
          <th
            class="p-1 left-align"
          [ngClass]="{
            'text-center': column === 'datasheet'
          }"
            >
            {{ app.field.getTableLabel("manufacturer." + column) }}
            <!-- {{ app.field.getLabel("manufacturer." + column) }} -->
          </th>
        }
      </tr>
    </thead>
    <tbody>
      <tr>
        @for (column of matchedItemColumns; track column) {
          <td
            class="ps-1"
            >
            @switch (app.table.getColumnTypeDisplay(column)) {
              @case ('optionText') {
                <div class="p-1">
                  {{ app.manufacturer.currentManufacturer["manufacturer." + column] }}
                </div>
              }
              @case ('badge') {
                <div>
                  @if (app.manufacturer.currentManufacturer['manufacturer.' + column] !== 'withoutData') {
                    <span
                      class="p-1 text-center badge"
              [ngStyle]="
                app.field.getColor(
                  'manufacturer.' + column,
                  app.manufacturer.currentManufacturer['manufacturer.' + column]
                )
              "
                      >
                      {{
                      app.field.getOptionText(
                      "manufacturer." + column,
                      app.manufacturer.currentManufacturer["manufacturer." + column]
                      )
                      }}
                    </span>
                  }
                </div>
              }
              @case ('link') {
                <div class="p-1">
                  <span>
                    @if (
                      app.manufacturer.currentManufacturer['manufacturer.' + column]
                      ) {
                      <a
                        class="icon-blue"
                        target="_blank"
                [href]="
                  app.manufacturer.currentManufacturer['manufacturer.' + column]
                "
                        >
                        <i class="fas fa-file"></i>
                      </a>
                    }
                  </span>
                </div>
              }
              @case ('normal') {
                <div class="text-left">
                  {{ app.manufacturer.currentManufacturer["manufacturer." + column] }}
                </div>
              }
              @case ('navigateAction') {
                <div>
                  {{ app.manufacturer.currentManufacturer["manufacturer." + column] }}
                </div>
              }
            }
          </td>
        }
      </tr>
    </tbody>
  </table>
  <br />

  @if (app.manufacturerUtils.substitutes.length != 0) {
    <button
      class="btn btn-sm btn-clean pull-right mb-3"
      (click)="app.manufacturerUtils.exportTables()"
      >
      <i class="fa fa-download"></i>&nbsp; {{ app.text.manufacturer.export }}
    </button>
  }

  <table class="table table-striped">
    <thead>
      <tr>
        @for (column of cleanColumns; track column) {
          <th
            class="p-1 left-align"
          [ngClass]="{
            'text-center':
              column === 'datasheet' || column === 'createManufacturer'
          }"
            >
            <!-- sorting + labels -->
            @if (column === 'createManufacturer') {
              <div>
                <i class="fad fa-industry-alt"></i>
              </div>
            }
            @if (column !== 'createManufacturer') {
              <div>
                <span
              (click)="
                app.table.toggleSortDirection('manufacturer.' + column);
                app.table.sort(app.manufacturerUtils.substitutes)
              "
                  >
                  {{ getColumnLabel(column) }}
                </span>
                @if ('manufacturer.' + column === app.table.sortField) {
                  <span>
                    @if (app.table.sortDirection === 1) {
                      <i
                        class="fa fa-chevron-up"
                      ></i>
                    }
                    @if (app.table.sortDirection === -1) {
                      <i
                        class="fa fa-chevron-down"
                      ></i>
                    }
                  </span>
                }
              </div>
            }
            <!-- filtering on the table heads -->
            @if (app.filterTable.getFilterTableColumns(column)) {
              <div>
                <app-filter-table
                  [column]="column"
                  [columns]="cleanColumns"
                  [docType]="'manufacturer'"
                  [cleanDocs]="app.manufacturerUtils.cleanSubstitutes"
                  [selectedFilters]="selectedFilters"
              (resultedDocs)="
                app.filterTable.getFilterResults($event, 'replacements')
              "
                  >
                </app-filter-table>
              </div>
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (
        id of showPaginator
        ? app.paginator.getPage(app.manufacturerUtils.substitutes)
        : app.manufacturerUtils.substitutes
        ; track
        id) {
        <tr
          [ngClass]="{ isSelected: app.isSelected(id) }"
          >
          @for (column of cleanColumns; track column) {
            <td class="p-1 text-center">
              <div>
                @switch (app.table.getColumnTypeDisplay(column)) {
                  @case ('navigateAction') {
                    <div>
                      {{ id[column] }}
                    </div>
                  }
                  @case ('optionText') {
                    <div>
                      <span class="text-center">
                        {{
                        app.field.getOptionText("manufacturer." + column, id[column])
                        }}
                      </span>
                    </div>
                  }
                  @case ('textCenter') {
                    <div>
                      @if (showValue(column, id[column])) {
                        <span class="text-center">
                          {{
                          app.field.getOptionText("manufacturer." + column, id[column])
                          }}
                        </span>
                      }
                    </div>
                  }
                  @case ('badge') {
                    <div>
                      @if (id[column] !== 'withoutData') {
                        <span
                          class="badge text-center"
                [ngStyle]="
                  app.field.getColor('manufacturer.' + column, id[column])
                "
                          >
                          {{
                          app.field.getOptionText("manufacturer." + column, id[column])
                          }}
                        </span>
                      }
                    </div>
                  }
                  @case ('link') {
                    <div>
                      @if (id[column]) {
                        <a
                          class="icon-blue"
                          target="_blank"
                          [href]="id[column]"
                          >
                          <i class="fas fa-file"></i>
                        </a>
                      }
                    </div>
                  }
                  @case ('actions') {
                    <div>
                      @if (!id.isAdded) {
                        <a
                          class="btn btn-sm btn-default-orange"
                (click)="
                  app.manufacturer.selectedManufacturer = id;
                  app.state.createFromPart = false;
                  createManufacturer.open()
                "
                          [ngbTooltip]="app.text.manufacturer.createNewManufacturer"
                          >
                          <i class="fas fa-plus"></i>&nbsp;&nbsp;{{ app.text.app.add }}</a
                          >
                        }
                        @if (id.isAdded) {
                          <div class="btn btn-sm btn-selected">
                            {{ app.text.app.added }}
                          </div>
                        }
                      </div>
                    }
                    @case ('normal') {
                      <div>
                        @if (showValue(column, id[column])) {
                          <span>
                            {{ id[column] }}
                          </span>
                        }
                      </div>
                    }
                  }
                </div>
              </td>
            }
          </tr>
        }
        <tr>
          @if (showLoading && !showNoResults) {
            <td
              colspan="99"
              class="text-center"
              >
              {{ app.text.manufacturer.loadingReplacement }}
            </td>
          }
          @if (showNoResults) {
            <td colspan="99" class="text-center">
              {{ app.text.manufacturer.replacementsNoResults }}
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
